import { FieldNames } from 'v2/core/entities/fields';
import { EQLFunctionName } from 'v2/core/repository/eql/types';

export const getCountForFieldEQLFunction = (
  fieldName: FieldNames | undefined,
) => {
  switch (fieldName) {
    case FieldNames.Language:
      return EQLFunctionName.CountForLanguages;
    case FieldNames.Metadata:
      return EQLFunctionName.CountForMetadataValues;
    case FieldNames.Entity:
    case FieldNames.Reason:
      return EQLFunctionName.CountForLabels;
    case FieldNames.Source:
    case FieldNames.ReviewSentiment:
      return EQLFunctionName.CountFor;
    default:
      return null;
  }
};
